var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{attrs:{"data":_vm.items},on:{"selection-change":_vm.selectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._l((_vm.rfidConfig.heapSelectColumns),function(item,idx){return _c('el-table-column',{key:idx,attrs:{"label":item.label,"prop":item.prop}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }